<div class="container-fluid col-lg-4 h-75">
    <div class="scanner-container">
        <div class="scanner-header">
            <mat-icon aria-hidden="false" aria-label="close-icon" fontIcon="close" class="material-symbols-rounded text-white"
                 (click)="navigateToPreviousScreen()"></mat-icon>
            <span class="text-white">Scan Barcode</span>
            <div class="icons">
                <mat-icon aria-hidden="false" aria-label="help-icon" fontIcon="help" class="material-symbols-rounded text-white"
                    ></mat-icon>
            </div>
        </div>

        <div class="h-75">
            <app-barcode-scanner></app-barcode-scanner>
        </div>
        <div fixed-bottom class="w-100 bg-success">
            <div class="instructions"><span class="bg-black">&nbsp;Point your camera at a barcode&nbsp;</span></div>
        </div>
    </div>
</div>